import React from 'react';
import { ArrivalDepratureValidator } from '../../../../assets/javascripts/registration-validator.js'


function AmountSelectorContainer({ labels, event_data }) {
    return (
        <table>
            {event_data.amount_reduced !== '' && (
                <tr>
                    <td>
                        <input type="radio"
                               name="beitrag" value="reduced" id="amount_reduced" />
                        <label htmlFor="amount_reduced">
                            {labels.addons.amount.reduced_amount} (
                            {event_data.amount_reduced})
                        </label>
                    </td>
                </tr>
            )}
            <tr>
                <td>
                    <input defaultChecked={"checked"} type="radio" name="beitrag" value="regular" id="amount_regular"/>
                    <label htmlFor="amount_regular">
                        {labels.addons.amount.regular_amount} (
                        {event_data.amount_participant})
                    </label>
                </td>
            </tr>

            {event_data.amount_social !== '' && (
                <tr>
                    <td>
                        <input name="beitrag" value="social" id="amount_social" type="radio"/>
                        <label htmlFor="amount_social">
                            {labels.addons.amount.social_amount} (
                            {event_data.amount_social})
                        </label>
                    </td>
                </tr>
            )}
        </table>
    );
}

export default AmountSelectorContainer;